import { lazy, Suspense } from "react";
import { Routes as _Routes, Route } from "react-router";
import { AppHeader } from "./components/app-header";
import { DashboardGuard } from "./components/dashboard-guard";
import { AuthGuard } from "./components/auth-guard";
import { AdminGuard } from "./components/admin-guard";

const LandingPage = lazy(() =>
  import("./pages/landing-page").then((m) => ({ default: m.LandingPage })),
);
const LoginPage = lazy(() => import("./pages/login-page").then((m) => ({ default: m.LoginPage })));
const RegisterPage = lazy(() =>
  import("./pages/register-page").then((m) => ({ default: m.RegisterPage })),
);
const SubmitPage = lazy(() =>
  import("./pages/submit-page").then((m) => ({ default: m.SubmitPage })),
);
const DashboardPage = lazy(() =>
  import("./pages/dashboard-page").then((m) => ({ default: m.DashboardPage })),
);
const AdminPage = lazy(() => import("./pages/admin-page").then((m) => ({ default: m.AdminPage })));
const MyEvaluationsPage = lazy(() =>
  import("./pages/my-evaluations-page").then((m) => ({ default: m.MyEvaluationsPage })),
);
const EvaluationsPage = lazy(() =>
  import("./pages/evaluations-page").then((m) => ({ default: m.EvaluationsPage })),
);
const LeaderboardRoute = lazy(() =>
  import("./pages/leaderboard-route").then((m) => ({ default: m.LeaderboardRoute })),
);
const PublicProfileRoute = lazy(() =>
  import("./pages/public-profile-route").then((m) => ({ default: m.PublicProfileRoute })),
);

export const Routes = () => {
  return (
    <>
      <AppHeader />
      <Suspense fallback={null}>
        <_Routes>
          <Route element={<AuthGuard />}>
            <Route path="" element={<LandingPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
          </Route>
          <Route path="leaderboard" element={<LeaderboardRoute />} />
          <Route path="users/:username" element={<PublicProfileRoute />} />
          <Route path="users/id/:userId" element={<PublicProfileRoute />} />
          <Route element={<DashboardGuard />}>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="evaluations" element={<MyEvaluationsPage />} />
            <Route path="submit" element={<SubmitPage />} />
          </Route>
          <Route element={<AdminGuard />}>
            <Route path="admin" element={<AdminPage />} />
            <Route path="admin/evaluations" element={<EvaluationsPage />} />
          </Route>
        </_Routes>
      </Suspense>
    </>
  );
};
